import runtimeConfig from '../../../runtimeConfig';
import React, { useEffect, useState, useCallback, useRef  } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { MdArrowBack } from 'react-icons/md';
import { FaRegEye } from "react-icons/fa6";
import server from '../../../api/server.js';
import FeedbackLayout from "../../layouts/FeedbackLayout.jsx"
import FeedbackSection from "../../layouts/FeedbackSection.jsx"
import { MdOutlineExpandMore } from "react-icons/md";
import { MdOutlineExpandLess } from "react-icons/md";
import { FaSmile, FaLightbulb, FaSearch, FaComments, FaUser, FaFileAlt, FaQuestionCircle, FaRegFileAlt } from "react-icons/fa";
import { CgAdd, CgTranscript } from "react-icons/cg";
import { AiOutlineAudio } from "react-icons/ai";
import { MdDensitySmall } from "react-icons/md";
import { VscFeedback } from "react-icons/vsc";
import { PiWarningCircle } from "react-icons/pi";
import '../../../dashboard-components/loader.css';
import { RiSurveyLine } from 'react-icons/ri';
import { IoIosPersonAdd } from 'react-icons/io';
import AddSampleModal from '../../layouts/AddSampleModal.jsx';
import { FaTimes } from 'react-icons/fa';
import { useToast } from '../../../context/ToastContext.jsx';
import { IoAdd, IoRefresh } from "react-icons/io5";
import { IoChatboxEllipsesOutline } from "react-icons/io5";
import { BiLeftArrow, BiRightArrow } from 'react-icons/bi';
import { GoDotFill } from "react-icons/go";
import { ChevronsLeft, ChevronsRight, Menu } from 'lucide-react';
import { MoreVertical } from 'lucide-react';
import { PanelsTopLeft } from 'lucide-react';
import { PencilLine } from 'lucide-react';
import { SingleRowSegmentedChart } from '../../layouts/ChartLayout.jsx';

const CallDetails = ({selectedOption, open_type, callIdProp, selectedClientId, selectedSegment, selectedTab}) => {
  const { showToast } = useToast();
  const { callId } = useParams();
  const [showMoreMap, setShowMoreMap] = useState({});
  const [historicalSource, setHistoricalSource] = useState(null);
  const [service_id, setService_id] = useState(null)
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true)
  const [s3URL, setS3URL] = useState("");
  const [client_id, setClient_id] = useState(null);
  const [anthroId, setAnthroId] = useState(null);
  const [sections, setSections] = useState([])
  const [segments, setSegments] = useState([])
  const audioRef = useRef(null);
  const transcriptRef = useRef(null);
  const segmentRefs = useRef([]);
  const sourceClickInProgressRef = useRef(false);
  const [showOverview, setShowOverview] = useState(true)
  const [email, setEmail] = useState(null)
  const [selectedSegmentIdx, setSelectedSegmentIdx] = useState(0)
  const [expandedSection, setExpandedSection] = useState(0);
  const [hoveredTab, setHoveredTab] = useState(null);
  const [segmentLoading, setSegmentLoading] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false)
  const [recordType, setRecordType] = useState(null)
  const [chatTranscriptions, setChatTranscriptions] = useState([])
  const [selectedSection, setSelectedSection] = useState(null)
  const tabRowRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const [agentCallTime, setAgentCallTime] = useState(0);
  const [customerCallTime, setCustomerCallTime] = useState(0);
  const [deadAirTime, setDeadAirTime] = useState(0);
  const [rateOfSpeechAgent, setRateOfSpeechAgent] = useState(0);
  const [rateOfSpeechCustomer, setRateOfSpeechCustomer] = useState(0);
  const [isRerunPrechecking, setIsRerunPrechecking] = useState(false);
  const [isRerunApplying, setIsRerunApplying] = useState(false);
  const [showRerunConfirm, setShowRerunConfirm] = useState(false);
  const [rerunTotalCost, setRerunTotalCost] = useState(0);
  const [rerunCurrentBalance, setRerunCurrentBalance] = useState(0);
  const [rerunAffectedCount, setRerunAffectedCount] = useState(0);
  const [canProceedRerun, setCanProceedRerun] = useState(false);
  const [showActionsMenu, setShowActionsMenu] = useState(false);
  const [rerunBalanceValid, setRerunBalanceValid] = useState(0);
  
  // Audio state management
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [audioReady, setAudioReady] = useState(false);
  const [pendingSourceClick, setPendingSourceClick] = useState(null);
  
  // Track if initial tab selection has happened
  const initialTabSetRef = useRef(false);
  
  // Track manual segment selection to prevent automatic scrolling
  const manualSegmentSelectionRef = useRef(false);

  const handleMouseEnter = (tab) => {
    setHoveredTab(tab);
  };

  const handleMouseLeave = () => {
    setHoveredTab(null);
  };
  const handleCloseAddModal = () => {
    setShowAddModal(false);
  }
  const handleSaveSample = async (id, module_name) => {
    try {
        setLoading(true);
        let res = await server.postTestSamples({client_id, service_id, email, id, module_name, 'menu': 'apps', 'submenu': undefined})
        if(res.status !== 200){
          let resp = await res.json()
          showToast(resp.error, "error")
        }
        setShowAddModal(false);
        setLoading(false);
    } catch (error) {
        setLoading(false);
    }
  }
  const handleSaveAddModalData = (config) => {
      if(config){
          if(config.call_id && config.module_name){
              handleSaveSample(config.call_id, config.module_name.toLowerCase().replaceAll(' ', '_'))
          }
      }
  }

  const getBoxShadow = (tab) => {
    if (hoveredTab === tab) {
      return "0 4px 8px rgba(0, 0, 0, 0.2)";
    }
    return "";
  };

  // Compute filteredSections once per render
  const filteredSections = sections.filter(section => Array.isArray(section.data) ? section.data.length > 0 : section.data)

  // Ensure selectedSection is always in sync with filteredSections
  useEffect(() => {
    if (filteredSections.length > 0) {
      if (selectedTab && !initialTabSetRef.current) {
        // Only set tab on first mount or when selectedTab changes
        const tabIndex = filteredSections.findIndex(section => section.title === selectedTab);
        if (tabIndex !== -1) {
          setExpandedSection(tabIndex);
          setSelectedSection(filteredSections[tabIndex]);
        } else {
          setExpandedSection(0);
          setSelectedSection(filteredSections[0]);
        }
        initialTabSetRef.current = true;
      } else {
        // Only update if not initial tab set
        const idx = (expandedSection != null && expandedSection < filteredSections.length) ? expandedSection : 0;
        setSelectedSection(filteredSections[idx]);
      }
    } else {
      setSelectedSection(null);
    }
  }, [sections, expandedSection, selectedTab, filteredSections]);

  // Reset initialTabSetRef if selectedTab changes
  useEffect(() => {
    initialTabSetRef.current = false;
  }, [selectedTab]);

  // Handle auto-expanding parameters when opening specific tabs
  useEffect(() => {
    if (selectedTab && selectedSegment && data && showMoreMap) {
      // Auto-expand the relevant parameter based on selectedSegment
      const updatedShowMoreMap = { ...showMoreMap };
      
      // Handle different tab types
      if (selectedTab === "Business Insights" && selectedSegment.parameter_name) {
        // Find the business insight index
        data?.business_insights?.forEach((insight, idx) => {
          if (insight.parameter_name === selectedSegment.parameter_name) {
            updatedShowMoreMap[`Business Insights - ${idx}`] = true;
          }
        });
      } else if (selectedTab === "Agent Feedback" && selectedSegment.parameter_name) {
        // Find the agent feedback parameter index
        data?.agent_feedback?.parameters?.forEach((param, idx) => {
          if (param.parameter_name === selectedSegment.parameter_name) {
            updatedShowMoreMap[`Agent Feedback - ${idx}`] = true;
          }
        });
      } else if (selectedTab === "Concern & Queries" && selectedSegment.concern_category) {
        // Find the concern index
        data?.concerns_and_queries?.ans?.forEach((concern, idx) => {
          if (concern.concern_category === selectedSegment.concern_category) {
            updatedShowMoreMap[`Concern and Queries - ${idx}`] = true;
          }
        });
      } else if (selectedTab === "Customer Feedback" && selectedSegment.feedback_category) {
        // Find the feedback index
        data?.customer_feedback?.ans?.forEach((feedback, idx) => {
          if (feedback.feedback_category === selectedSegment.feedback_category) {
            updatedShowMoreMap[`Customer Feedback - ${idx}`] = true;
          }
        });
      } else if (selectedTab === "Lead Quality" && selectedSegment.lead_parameter) {
        // Find the lead quality index
        data?.lead_quality?.forEach((lead, idx) => {
          if (lead.parameter_name === selectedSegment.lead_parameter) {
            updatedShowMoreMap[`Lead Quality - ${idx}`] = true;
          }
        });
      }
      
      // Update showMoreMap if any changes were made
      if (JSON.stringify(updatedShowMoreMap) !== JSON.stringify(showMoreMap)) {
        setShowMoreMap(updatedShowMoreMap);
      }
    }
  }, [selectedTab, selectedSegment, data, showMoreMap]);

  // Handle selectedSegment when segments are loaded
  useEffect(() => {
    if (selectedSegment && audioReady) {
      // Small delay to ensure everything is ready
      setTimeout(() => {
        handleSourceClick(selectedSegment);
      }, 500);
    } else if (selectedSegment && !audioReady) {
      handleSourceClick(selectedSegment);
      // Store for later when audio is ready
      setPendingSourceClick(selectedSegment);
    }
  }, [selectedSegment, audioReady, segments, chatTranscriptions]);

  // Cleanup audio when component unmounts or audio changes
  useEffect(() => {
    return () => {
      if (audioRef.current) {
        // Remove all event listeners
        if (audioRef.current._sourceClickHandler) {
          audioRef.current.removeEventListener('timeupdate', audioRef.current._sourceClickHandler);
          audioRef.current._sourceClickHandler = null;
        }
        // Pause audio
        audioRef.current.pause();
      }
      // Clear flags
      sourceClickInProgressRef.current = false;
    };
  }, [s3URL]);

  const toggleSection = (index) => {
    setExpandedSection((prev) => (prev === index ? index : index));
    setSelectedSection(filteredSections[index]);
  };
  const selectedOptionRef = useRef(selectedOption);
  selectedOptionRef.current = selectedOption;
  function getCookie(name) {
      function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
      var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
      return match ? match[1] : null;
  }
  const getChatTranscriptionData = async (anthro_id, clientId, email) => {
    try {
      setSegmentLoading(true)
      let res = await server.getChatTranscriptionData(anthro_id, clientId, selectedOptionRef.current, 'conversations', undefined, email, window.location.href);
      if(res.status === 200){
        let response = await res.json()
        setChatTranscriptions(response.data || []);
        setSegmentLoading(false)
      }else{
        setChatTranscriptions([]);
        setSegmentLoading(false)
      }
    } catch (error) {
      setSegmentLoading(false);
    }
  }
  const getCallRecordingLink = async (call_id, clientId, email) => {
    try {
      setSegmentLoading(true)
      let res = await server.getCallRecordingLink(call_id, clientId, selectedOptionRef.current, 'conversations', undefined, email, window.location.href);
      if(res.status === 200){
        let response = await res.json()
        // const convertedURL = await convertAudio(response.data.pre_signed_url);
        setS3URL(response.data.pre_signed_url);
        setSegments(response.data.segments.data || []);
        setAgentCallTime(response.data.segments.meta_analytics.agent_talk_duration);
        setCustomerCallTime(response.data.segments.meta_analytics.customer_talk_duration);
        setDeadAirTime(response.data.segments.meta_analytics.dead_air_duration);
        setRateOfSpeechAgent(response.data.segments.meta_analytics.rate_of_speech_agent);
        setRateOfSpeechCustomer(response.data.segments.meta_analytics.rate_of_speech_customer);
        setSegmentLoading(false)
      }else{
        setSegments([]);
        setSegmentLoading(false)
      }
    } catch (error) {
      setSegmentLoading(false)
    }
  };
  const formatTime = (timeInSeconds) => {
    timeInSeconds = parseInt(timeInSeconds)
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = Math.floor(timeInSeconds % 60);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };
  const getEnabledModulesList = async () => {
    try {
      let res = await server.defaultModuleStatus(client_id, Array.isArray(service_id) ? service_id[0] : service_id, email, 'apps', undefined);
      if (res.status === 200) {
        const resp = await res.json();
        const modules = (resp.data || []).filter(m => m.status === true).map(m => m.module_name);
        return modules;
      }
    } catch (e) {}
    return [];
  };

  const buildRerunConfig = (conversationIds) => {
    const cfg = {
      conversation_ids: conversationIds,
      processing_status: ['completed', 'error'],
      date_range: { start: '', end: '' }
    };
    if (recordType) {
      cfg.record_type = [recordType];
    } else {
      cfg.record_type = ['call', 'chat'];
    }
    return cfg;
  };

  const handleRerunAppsClick = async () => {
    try {
      if (isRerunPrechecking || isRerunApplying || loading) return;
      setIsRerunPrechecking(true);

      const actualCallId = callIdProp ? callIdProp : (callId ? decodeURIComponent(callId) : callId);
      const conversationIds = actualCallId ? [actualCallId] : [];
      if (conversationIds.length === 0) {
        showToast('No conversations found to rerun.', 'error');
        setIsRerunPrechecking(false);
        return;
      }

      const modules = await getEnabledModulesList();
      if (!modules || modules.length === 0) {
        showToast('No enabled apps to rerun. Enable apps in Apps Management.', 'error');
        setIsRerunPrechecking(false);
        return;
      }

      const config = buildRerunConfig(conversationIds);
      config.modules_list = modules;

      let resp = await server.checkConversationChanges(
        client_id,
        Array.isArray(service_id) ? service_id[0] : service_id,
        email,
        'apps',
        undefined,
        config
      );

      if (resp.status === 200) {
        const data = await resp.json();
        setRerunTotalCost(data.total_cost || 0);
        setRerunCurrentBalance(data.current_balance || 0);
        setRerunAffectedCount(data.total_count || 0);
        setRerunBalanceValid(data.valid || 0);
        setCanProceedRerun(((data.total_cost || 0) <= (data.current_balance || 0)) || data.valid === 1);
      // Store config for apply
      setPendingRerunConfig(config);
        setShowRerunConfirm(true);
      } else {
        try {
          const err = await resp.json();
          showToast(err.error || 'Failed to pre-check changes.', 'error');
        } catch (_) {
          showToast('Failed to pre-check changes.', 'error');
        }
      }
    } catch (error) {
      showToast('Failed to pre-check changes.', 'error');
    } finally {
      setIsRerunPrechecking(false);
    }
  };

  const [pendingRerunConfig, setPendingRerunConfig] = useState(null);
  const handleRerunApply = async () => {
    try {
      if (!pendingRerunConfig) return;
      setIsRerunApplying(true);
      let res = await server.applyConversationChanges({
        client_id,
        service_id: Array.isArray(service_id) ? service_id[0] : service_id,
        email,
        menu: 'apps',
        submenu: undefined,
        configuration: pendingRerunConfig
      });
      if (res.status === 200) {
        showToast('Modules are being processed. You will be notified once the changes are applied.', 'success');
        setShowRerunConfirm(false);
        setPendingRerunConfig(null);
      } else {
        try {
          const err = await res.json();
          showToast(err.error || 'Failed to apply changes.', 'error');
        } catch (_) {
          showToast('Failed to apply changes.', 'error');
        }
      }
    } catch (error) {
      showToast('Failed to apply changes.', 'error');
    } finally {
      setIsRerunApplying(false);
    }
  };

  const handleCloseRerunConfirm = () => {
    if (isRerunApplying) return;
    setShowRerunConfirm(false);
  };
  function formatEpochTime(epochMillis) {
    if (typeof epochMillis !== 'number' || epochMillis.toString().length !== 13) {
      throw new Error('Input must be a 13-digit epoch timestamp in milliseconds.');
    }
  
    const date = new Date(epochMillis);
    return date.toLocaleString(); // e.g., "5/29/2025, 2:30:45 PM"
  }
  

  // Function to handle segment click
  const toggleSegment = (item, idx) => {
    if (!audioRef.current || !audioReady) {
      console.warn('Audio not ready for segment click');
      return;
    }
    
    try {
      // Set flags to prevent automatic updates
      sourceClickInProgressRef.current = true;
      manualSegmentSelectionRef.current = true;
      
      // Update segment selection
      setSelectedSegmentIdx(idx);
      
      // Pause current playback
      audioRef.current.pause();
      
      // Remove existing source click handler
      if (audioRef.current._sourceClickHandler) {
        audioRef.current.removeEventListener('timeupdate', audioRef.current._sourceClickHandler);
        audioRef.current._sourceClickHandler = null;
      }
      
      // Seek to segment start time
      audioRef.current.currentTime = item.start_time;
      
      // Play audio
      setTimeout(() => {
        const playPromise = audioRef.current.play();
        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              setIsPlaying(true);
              sourceClickInProgressRef.current = false;
              // Clear manual selection flag after a delay to allow normal playback
              setTimeout(() => {
                manualSegmentSelectionRef.current = false;
              }, 300);
            })
            .catch(error => {
              console.warn('Error playing audio for segment click:', error);
              sourceClickInProgressRef.current = false;
              manualSegmentSelectionRef.current = false;
              setIsPlaying(false);
            });
        }
      }, 100);
      
    } catch (error) {
      console.warn('Error in segment click:', error);
      sourceClickInProgressRef.current = false;
      manualSegmentSelectionRef.current = false;
      setIsPlaying(false);
    }
  };

  // Smooth scroll helper to keep some space from top when focusing a segment/chat
  const scrollChildWithOffset = (childEl, offset = 80) => {
    const container = transcriptRef.current;
    if (!container || !childEl) return;
    try {
      const parentTop = container.getBoundingClientRect().top;
      const childTop = childEl.getBoundingClientRect().top;
      const delta = childTop - parentTop;
      container.scrollTo({ top: container.scrollTop + delta - offset, behavior: 'smooth' });
    } catch (_) {}
  };

  // Sync segment selection with audio playback
  const handleAudioTimeUpdate = () => {
    if (audioRef.current && !sourceClickInProgressRef.current && !manualSegmentSelectionRef.current) {
      const time = audioRef.current.currentTime;
      setCurrentTime(time);
      
      // Update segment selection based on current time
      segments.forEach((segment, idx) => {
        if (time >= segment.start_time && time <= segment.end_time) {
          if (selectedSegmentIdx !== idx) {
            setSelectedSegmentIdx(idx);
            // Only scroll if we're not doing manual segment selection
            scrollChildWithOffset(segmentRefs.current[idx], 150);
          }
        }
      });
    }
  };

  // Audio event handlers
  const handleAudioLoad = () => {
    if (audioRef.current) {
      setDuration(audioRef.current.duration);
      setAudioReady(true);
      
      // Handle pending source click if any
      if (pendingSourceClick) {
        handleSourceClick(pendingSourceClick);
        setPendingSourceClick(null);
      }
    }
  };

  const handleAudioPlay = () => {
    setIsPlaying(true);
    sourceClickInProgressRef.current = false;
  };

  const handleAudioPause = () => {
    setIsPlaying(false);
  };

  const handleAudioEnded = () => {
    setIsPlaying(false);
    setCurrentTime(0);
  };

  const handleAudioError = (error) => {
    setIsPlaying(false);
    setAudioReady(false);
    sourceClickInProgressRef.current = false;
  };

  const getCallDetails = async (hardRefresh = false) => {
    const user = getCookie("dashboard_login_user_creds")
      ? JSON.parse(getCookie("dashboard_login_user_creds"))
      : null;

    if (user) {
      let clientId = selectedClientId;
      let email = user.email
      // Decode the callId if it comes from URL params (it would be encoded)
      const actualCallId = callIdProp ? callIdProp : (callId ? decodeURIComponent(callId) : callId);
      setClient_id(selectedClientId)

      try {
        setLoading(true);
        setS3URL("");
        setSegments([]);
        setChatTranscriptions([]);
        let res = await server.getCallDetails(clientId, selectedOptionRef.current, actualCallId, 'conversations', undefined, email, window.location.href, hardRefresh);
        if (res.status === 200) {
          let resp = await res.json();
          setData(resp.data); // Update data here
          setSections([
            {title: "Overview", dataKey: "Overview", data: {...resp.data, call_id: actualCallId}},
            {title: "Conversation Summary", dataKey: "Conversation Summary", data: resp.data?.conversation_summary},
            {title: "Agent Feedback", dataKey: "Agent Feedback", data: resp.data?.agent_feedback?.parameters, metadata: {'overall': {...resp.data?.agent_feedback?.overall, 'fatal': resp.data?.agent_feedback?.fatal, 'fatal_trigger_parameters': resp.data?.agent_feedback?.fatal_trigger_parameters}}},
            { title: "Business Insights", dataKey: "Business Insights", data: resp.data?.business_insights },
            {title: "Lead Quality", dataKey: "Lead Quality", data: resp.data?.lead_quality},
            {title: "Custom Module", dataKey: "Custom Module", data: resp.data?.custom_module},
            {title: "Concern & Queries", dataKey: "Concern & Queries", data: resp.data?.concerns_and_queries?.ans},
            {title: "Customer Feedback", dataKey: "Customer Feedback", data: resp.data?.customer_feedback?.ans},
            { title: "Soft Skills", dataKey: "Soft Skills", data: resp.agent_feedback_soft_skills },
            { title: "Adherence to Script", dataKey: "Adherence to Script", data: resp.agent_feedback_adherence_to_script },
            { title: "Escalations Deep Dive", dataKey: "Escalations", data: resp.escalations },
            {title: "Dispositions & Subdispositions", dataKey: "Dispositions", data: resp.data?.conversation_dispositions},
            {title: "Templates", dataKey: "Templates", data: resp.data?.templates ? Object.entries(resp.data?.templates).map(([key, value]) => ({
              display_name: key==='sms' ? 'SMS' : key==='whatsapp' ? 'WhatsApp' : 'Email',
              output: {...value}
            })) : []}
          ]);
          if(resp.data && resp.data?.record_type === 'call'){
            setRecordType('call')
            getCallRecordingLink(actualCallId, clientId, email);
          }else{
            setRecordType('chat')
            setAnthroId(resp.data?.anthro_id);
            getChatTranscriptionData(resp.data?.anthro_id, clientId, email);
          }
        }else{
        setData(null);
      }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setData(null);
        console.error(error);
      }
    }
  };

  const handleHardRefresh = async () => {
    if (loading) return;
    await getCallDetails(true);
  };

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };
  
  const debouncedGetCallDetails = useCallback(debounce(getCallDetails, 300), []);
  
  useEffect(() => {
    if (selectedOption && selectedClientId) {
      debouncedGetCallDetails();
    }
  }, [selectedOption, callId, debouncedGetCallDetails, callIdProp, email]);
  useEffect(()=> {
    if(selectedOption){
      setService_id(selectedOption)
    }
    if(selectedClientId){
      setClient_id(selectedClientId)
    }
    const user = getCookie("dashboard_login_user_creds")
      ? JSON.parse(getCookie("dashboard_login_user_creds"))
      : null;
    if(user){
      let email =user.email
      setEmail(email)
    }
  }, [selectedOption, selectedClientId, chatTranscriptions])
  
  useEffect(() => {
    // Dynamically build the initial showMoreMap based on `data`
    if (data) {
      const initialShowMoreMap = {};
      initialShowMoreMap['Overview'] = false;
      initialShowMoreMap[`Conversation Summary`] = false;
      initialShowMoreMap[`Dispositions`] = true;
      data?.concerns_and_queries?.ans?.forEach((_, idx) => {
        initialShowMoreMap[`Concern and Queries - ${idx}`] = false;
      });
      data?.customer_feedback?.ans?.forEach((_, idx) => {
        initialShowMoreMap[`Customer Feedback - ${idx}`] = false;
      });
      data?.templates && Array.isArray(data?.templates) && data?.templates?.forEach((_, idx) => {
        initialShowMoreMap[`Templates - ${idx}`] = false;
      });
      data?.agent_feedback && Array.isArray(data?.agent_feedback) && data?.agent_feedback?.forEach((_, idx) => {
        initialShowMoreMap[`Agent Feedback - ${idx}`] = false;
      });
      data?.lead_quality && Array.isArray(data?.lead_quality) && data?.lead_quality?.forEach((_, idx) => {
        initialShowMoreMap[`Lead Quality - ${idx}`] = true;
      });
      data?.custom_module && Array.isArray(data?.custom_module) && data?.custom_module?.forEach((_, idx) => {
        initialShowMoreMap[`Custom Module - ${idx}`] = false;
      });
      data?.personas && Array.isArray(data?.personas) && data?.personas?.forEach((_, idx) => {
        initialShowMoreMap[`Personas - ${idx}`] = false;
      });
      data?.agent_feedback_soft_skills?.forEach((_, idx) => {
        initialShowMoreMap[`Soft Skills - ${idx}`] = false;
      });
      data?.business_insights?.forEach((_, idx) => {
        initialShowMoreMap[`Business Insights - ${idx}`] = false;
      });
      data?.agent_feedback_adherence_to_script?.forEach((_, idx) => {
        initialShowMoreMap[`Adherence to Script - ${idx}`] = false;
      });
      data?.escalations?.forEach((_, idx) => {
        initialShowMoreMap[`Escalations - ${idx}`] = false;
      });
      setShowMoreMap(initialShowMoreMap);
    }
  }, [data]); // This will only run once when data is fetched or updated

  const toggleShowMore = (key) => {
    setShowMoreMap(prev => ({ ...prev, [key]: !prev[key] }));
  };
  const handleOpenModal = () => {
    setShowModal(true);
  }
  const navigate = useNavigate();
  const handleCloseModal = () => {
    setShowModal(false);
  }
  const handleGoBack = () => {
    if(callIdProp){
      open_type();
      return;
    }
    navigate(-1); // Navigate to the previous page in history
  };
  const renderIconHere = (title) => {
    switch (title) {
      case "Soft Skills":
        return <VscFeedback style={{ marginRight: "8px" }} />;
      case "Business Insights":
        return <FaLightbulb style={{ marginRight: "8px" }} />;
      case "Adherence to Script":
        return <CgTranscript style={{ marginRight: "8px" }} />;
      case "Escalations Deep Dive":
        return <FaSearch style={{ marginRight: "8px" }} />;
      case "Agent Feedback":
        return <VscFeedback style={{ marginRight: "8px" }} />;
      case "Personas":
        return <FaUser style={{ marginRight: "8px" }} />;
      case "Templates":
        return <FaFileAlt style={{ marginRight: "8px" }} />;
      case "Concern & Queries":
        return <PiWarningCircle style={{ marginRight: "5px", fontSize: "19px" }} />;
      case "Customer Feedback":
        return <RiSurveyLine style={{marginRight: "8px"}}/>
      case "Lead Quality":
        return <IoIosPersonAdd style={{marginRight: "8px"}}/>
      case "Conversation Summary":
        return <FaRegFileAlt style={{marginRight: "8px"}}/>
      case "Overview":
        return <Menu style={{marginRight: "8px", height: "16px"}}/>
      case "Dispositions & Subdispositions":
        return <PencilLine style={{marginRight: "8px", height: "16px"}}/>
      case "Custom Module":
        return <FaRegFileAlt style={{marginRight: "8px"}}/>
      default:
        return null; // No icon for unmatched titles
    }
  };
  const getBorderColor = (actor_type) => {
    switch (actor_type) {
      case 'user':
        return"4px solid #6f6ffe"
      case 'agent':
        return"4px solid #3B82F6"
      case 'bot':
        return"4px solid gray"
      case 'system':
        return "4px solid gray"
      default:
        break;
    }
  }
  const getBackgroundColor = (actor_type) => {
    switch (actor_type) {
      case 'user':
        return"rgb(249, 250, 251)"
      case 'agent':
        return"rgb(249, 250, 251)"
      case 'bot':
        return"rgb(249, 250, 251)"
      case 'system':
        return"rgb(249, 250, 251)"
      default:
        break;
    }
  }
  const convertToSeconds = (time) => {
    if (time === null || time === undefined) {
      return 0;
    }
    
    if (typeof time === 'number') {
      return time;
    }
    
    if (typeof time === 'string') {
      // Handle HH:MM:SS or MM:SS format first
      if (time.includes(':')) {
        const parts = time.split(':');
        if (parts.length === 3) {
          // HH:MM:SS format
          const [hours, minutes, seconds] = parts.map(Number);
          if (!isNaN(hours) && !isNaN(minutes) && !isNaN(seconds)) {
            const totalSeconds = (hours * 3600) + (minutes * 60) + seconds;
            return totalSeconds;
          }
        } else if (parts.length === 2) {
          // MM:SS format
          const [minutes, seconds] = parts.map(Number);
          if (!isNaN(minutes) && !isNaN(seconds)) {
            const totalSeconds = (minutes * 60) + seconds;
            return totalSeconds;
          }
        }
      }
      
      // Try to parse as a number (for strings like "14.5")
      const parsed = parseFloat(time);
      if (!isNaN(parsed)) {
        return parsed;
      }
    }
    
    // Last resort: try parseInt for pure numeric strings
    try {
      const intParsed = parseInt(time, 10);
      if (!isNaN(intParsed)) {
        return intParsed;
      }
    } catch (error) {
      console.warn('parseInt failed:', error);
    }
    
    console.warn('Unable to convert time to seconds:', time);
    return 0;
  }

  const handleSourceClick = (source) => {
    if (!source) return;
    const currentCallId = callIdProp || (callId ? decodeURIComponent(callId) : null);
    if (source.conversation_id && source.conversation_id !== currentCallId) {
      audioRef.current?.pause();
      setHistoricalSource(source);
      return;
    }
    if(source.open_url){
      let baseUrl = runtimeConfig.REACT_APP_ANTHROPOD_DASHBOARD_URL;
      window.open(`${baseUrl}/analytics/${client_id}/${source.service_id}/customers/${source.customer_id}`, '_blank');
      return;
    }
    
    let start, end, message_id;
    
    if (source.start_timestamp && source.end_timestamp) {
      // Handle audio segment case
      try {
        // Convert timestamps to seconds
        if (typeof source.start_timestamp === 'string') {
          start = convertToSeconds(source.start_timestamp) - 1;
        } else {
          start = parseFloat(source.start_timestamp) - 1;
        }
        
        if (typeof source.end_timestamp === 'string') {
          end = convertToSeconds(source.end_timestamp) + 1;
        } else {
          end = parseFloat(source.end_timestamp) + 1;
        }
        
        // Validate timestamps
        if (isNaN(start) || isNaN(end) || start >= end) {
          console.warn('Invalid timestamp values:', source.start_timestamp, source.end_timestamp);
          return;
        }
        
        // Check if audio is ready
        if (!audioRef.current || !audioReady) {
          console.warn('Audio not ready, storing for later');
          setPendingSourceClick(source);
          return;
        }
        
        // Find the segment index
        let segmentIdx = 0;
        for (let i = 0; i < segments.length; i++) {
          if (start >= segments[i].start_time && start <= segments[i].end_time) {
            segmentIdx = i;
            break;
          }
        }
        
        // Set flag to prevent automatic updates
        sourceClickInProgressRef.current = true;
        manualSegmentSelectionRef.current = true;
        
        // Step 1: Update UI immediately
        setSelectedSegmentIdx(segmentIdx);
        
        // Step 2: Scroll to segment (only the correct one)
        setTimeout(() => {
          if (segmentRefs.current[segmentIdx] && segmentIdx === selectedSegmentIdx) {
            segmentRefs.current[segmentIdx].scrollIntoView({
              behavior: "smooth",
              block: "nearest",
            });
          }
          
          // Step 3: Handle audio playback
          setTimeout(() => {
            try {
              if (!audioRef.current) return;
              // Pause current playback
              audioRef.current.pause();
              
              // Remove existing listeners
              if (audioRef.current._sourceClickHandler) {
                audioRef.current.removeEventListener('timeupdate', audioRef.current._sourceClickHandler);
                audioRef.current._sourceClickHandler = null;
              }
              
              // Create new timeupdate handler for this specific playback
              const sourceClickHandler = () => {
                if (!audioRef.current) return;
                
                const currentTime = audioRef.current.currentTime;
                
                // Stop playback when reaching end time
                if (currentTime >= end) {
                  audioRef.current.pause();
                  audioRef.current.removeEventListener('timeupdate', sourceClickHandler);
                  audioRef.current._sourceClickHandler = null;
                  sourceClickInProgressRef.current = false;
                  manualSegmentSelectionRef.current = false;
                  setIsPlaying(false);
                }
              };
              
              // Store and add the handler
              audioRef.current._sourceClickHandler = sourceClickHandler;
              audioRef.current.addEventListener('timeupdate', sourceClickHandler);
              
              // Seek to start time
              audioRef.current.currentTime = start;
              
              // Play with delay to ensure seek is complete
              setTimeout(() => {
                if (!audioRef.current) return;
                const playPromise = audioRef.current.play();
                if (playPromise !== undefined) {
                  playPromise
                    .then(() => {
                      setIsPlaying(true);
                      // Clear manual selection flag after a delay
                      setTimeout(() => {
                        manualSegmentSelectionRef.current = false;
                      }, 300);
                    })
                    .catch(error => {
                      console.warn('Error playing audio for source click:', error);
                      // The source popup may have closed while play() was pending.
                      if (!audioRef.current) return;
                      // Clean up on error
                      audioRef.current.removeEventListener('timeupdate', sourceClickHandler);
                      audioRef.current._sourceClickHandler = null;
                      sourceClickInProgressRef.current = false;
                      manualSegmentSelectionRef.current = false;
                      setIsPlaying(false);
                    });
                }
              }, 200);
              
            } catch (error) {
              console.warn('Error in source click audio handling:', error);
              sourceClickInProgressRef.current = false;
              manualSegmentSelectionRef.current = false;
              setIsPlaying(false);
            }
          }, 300); // Wait for scrolling
        }, 100); // Wait for UI update
        
      } catch (error) {
        console.warn('Error processing source click:', error);
        sourceClickInProgressRef.current = false;
      }
      
    } else if (source.segment_id) {
      // Handle chat message case
      message_id = source.segment_id;
      const message = chatTranscriptions.find(message => message.message_id === message_id);
      if (message) {
        const messageIndex = chatTranscriptions.findIndex(msg => msg.message_id === message_id);
        if (messageIndex !== -1) {
          setTimeout(() => {
            const container = transcriptRef.current;
            const messageElement = container ? container.querySelector(`[data-message-id="${message_id}"]`) : null;
            if (container && messageElement) {
              try {
                const parentTop = container.getBoundingClientRect().top;
                const childTop = messageElement.getBoundingClientRect().top;
                const delta = childTop - parentTop;
                container.scrollTo({ top: container.scrollTop + delta - 150, behavior: 'smooth' });
              } catch (_) {}
              // Add highlight effect
              messageElement.style.backgroundColor = "rgba(111, 111, 254, 0.1)";
              setTimeout(() => {
                messageElement.style.backgroundColor = "";
              }, 2000);
            }
          }, 100);
        }
      }else{
        const messageIndex = segments.findIndex(msg => msg.segment_id === message_id);
        if (messageIndex !== -1) {
          source = {
            'start_timestamp': segments[messageIndex].start_time,
            'end_timestamp': segments[messageIndex].end_time
          }
          handleSourceClick(source)
        }
      }
    }
  };

  // Check scroll position to show/hide arrows
  const checkTabRowScroll = () => {
    const el = tabRowRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 0);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
  };

  useEffect(() => {
    checkTabRowScroll();
    const el = tabRowRef.current;
    if (!el) return;
    el.addEventListener('scroll', checkTabRowScroll);
    window.addEventListener('resize', checkTabRowScroll);
    return () => {
      el.removeEventListener('scroll', checkTabRowScroll);
      window.removeEventListener('resize', checkTabRowScroll);
    };
  }, [filteredSections.length]);

  const scrollTabRow = (direction) => {
    const el = tabRowRef.current;
    if (!el) return;
    const scrollAmount = 240; // px
    el.scrollBy({ left: direction === 'left' ? -scrollAmount : scrollAmount, behavior: 'smooth' });
  };

  return (
    <div style={{ width: "100%", height: (window.location.href.includes('?token=')) ? window.innerHeight : window.innerHeight - 66.5, overflowY: "auto" }} class="bg-gray-50 px-5">
      {historicalSource && (
        <div className="fixed inset-0 bg-black bg-opacity-50" style={{ zIndex: 1001 }}>
          <div className="absolute bg-white rounded-lg shadow-lg" style={{ left: '2%', top: '3.5%', width: '96%', height: '93%' }}>
            <button aria-label="Close source conversation" className="absolute right-3 top-3 text-gray-500" style={{ zIndex: 2 }} onClick={() => setHistoricalSource(null)}><FaTimes /></button>
            <div className="h-full overflow-auto">
              <CallDetails
                key={historicalSource.conversation_id}
                selectedOption={selectedOption || service_id}
                selectedClientId={client_id}
                callIdProp={historicalSource.conversation_id}
                selectedSegment={historicalSource}
                selectedTab={selectedSection?.title}
                open_type={() => setHistoricalSource(null)}
              />
            </div>
          </div>
        </div>
      )}
      {
        !loading && (
          <>
          {!window.location.href.includes('?token=') && <div className={`flex ${callId && 'justify-between'}`}>
            <button onClick={handleGoBack} style={{display: 'flex',alignItems: 'center',color: '#4b5563',cursor: 'pointer',border: 'none',background: 'none',padding: '8px',fontSize: '14px',}}>
              <MdArrowBack style={{ marginRight: '8px' }} />
              Back
            </button>
            {callId && (
              <div className="flex items-center">
                <button onClick={()=> setShowAddModal(true)} className="flex items-center px-4 py-1 my-1" style={{fontSize: '14px', color: '#4b5563'}}>
                  <IoAdd/>
                  Add to Test Set
                </button>
                <button onClick={handleHardRefresh} disabled={loading} className="flex items-center px-4 py-1 my-1 ml-1" style={{fontSize: '14px', color: loading ? '#9ca3af' : '#4b5563'}}>
                  <IoRefresh/>
                  <span className="ml-1">{loading ? 'Refreshing...' : 'Refresh'}</span>
                </button>
                <div style={{ position: 'relative' }} className="ml-1">
                  <button onClick={() => setShowActionsMenu(prev => !prev)} disabled={isRerunPrechecking || isRerunApplying || loading} className="flex items-center px-2 py-1 my-1" style={{fontSize: '14px', color: (isRerunPrechecking || isRerunApplying || loading) ? '#9ca3af' : '#4b5563'}}>
                    <MoreVertical size={18} />
                  </button>
                  {showActionsMenu && (
                    <div style={{ position: 'absolute', right: 0, top: '100%', marginTop: '6px', background: 'white', border: '1px solid rgb(229,231,235)', borderRadius: '6px', boxShadow: '0 4px 10px rgba(0,0,0,0.08)', zIndex: 1000000000, minWidth: '160px' }}>
                      <div onClick={() => { setShowActionsMenu(false); handleRerunAppsClick(); }} style={{ padding: '8px 12px', fontSize: '14px', cursor: 'pointer' }} className="hover:bg-gray-50">Rerun Call</div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>}
          {
            !data ? (
              <>
              <div className="flex justify-center items-center" style={{ height: "100%", flexDirection: "column" }}>
                        <img src="/assets/paper.png" style={{height: "10vh"}} alt=""/>
                        <h2 style={{textAlign: "center", fontSize: "24px"}}>No Call Details Found.</h2>
                    </div>
              </>
            ) : (
              <div style={{display: "flex"}}>
      <div style={{flex: "0.65", overflowY: "auto", background: "white", borderRadius: "10px 10px 0 6px"}} className='shadow-sm'>
        {/* Tab Row: single horizontal, scrollable, no wrap */}
        <div style={{position: 'relative', width: '100%'}}>
          {/* Left Arrow */}
          {canScrollLeft && (
            <button
              onClick={() => scrollTabRow('left')}
              style={{
                position: 'absolute',
                left: 0,
                top: 0,
                bottom: 0,
                zIndex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                background: 'white',
                border: 'none',
                cursor: 'pointer',
                height: '97%',
                padding: 0,
                outline: 'none',
                transition: 'background 0.2s',
                pointerEvents: 'auto'
              }}
              aria-label="Scroll left"
            >
              <ChevronsLeft size={20} color="#808080" />
            </button>
          )}
          {/* Right Arrow */}
          {canScrollRight && (
            <button
              onClick={() => scrollTabRow('right')}
              style={{
                position: 'absolute',
                right: 0,
                top: 0,
                bottom: 0,
                zIndex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                background: 'white',
                border: 'none',
                cursor: 'pointer',
                height: '97%',
                padding: 0,
                outline: 'none',
                transition: 'background 0.2s',
                pointerEvents: 'auto'
              }}
              aria-label="Scroll right"
            >
              <ChevronsRight size={20} color="#808080" />
            </button>
          )}
          <div
            ref={tabRowRef}
            style={{
              display: "flex",
              overflowX: "auto",
              overflowY: "hidden",
              whiteSpace: "nowrap",
              alignItems: "center",
              padding: "0 4px",
              gap: "8px",
              borderRadius: "6px 0 0 0",
              borderBottom: "1.5px solid #e3e3e3",
              background: "white",
              scrollbarWidth: "none", // Firefox
              msOverflowStyle: "none", // IE/Edge
            }}
            className="custom-tab-scrollbar"
          >
            {filteredSections.map((section, idx) => (
              <div
                key={section.title}
                className={`sections-headings${expandedSection === idx ? " expanded" : ""}`}
                onClick={() => toggleSection(idx)}
                style={{
                  minWidth: "120px",
                  maxWidth: "320px",
                  width: "auto",
                  flex: "none",
                  margin: "0 2px",
                  padding: "10px",
                  borderRadius: "10px 10px 0 0",
                  borderBottom: expandedSection === idx ? "3.5px solid #6f6ffe" : "2px solid transparent",
                  marginBottom: expandedSection === idx ? "-1.5px" : "0",
                  zIndex: 1,
                  background: expandedSection === idx ? "white" : "rgba(255,255,255,0.28)",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  fontWeight: expandedSection === idx ? 500 : 400,
                  color: expandedSection === idx ? "#6f6ffe" : "#222",
                  fontSize: "15px",
                  justifyContent: "flex-start"
                }}
                title={section.title}
              >
                {renderIconHere(section.title)}
                <span style={{
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  display: "inline-block",
                  maxWidth: "220px"
                }}>{section.title}</span>
              </div>
            ))}
          </div>
          {/* Hide scrollbar with CSS */}
          <style>{`
            .custom-tab-scrollbar {
              scrollbar-width: none;
            }
            .custom-tab-scrollbar::-webkit-scrollbar {
              display: none;
            }
          `}</style>
        </div>
        {/* Section Content: only show selected section */}
        <div style={{marginTop: "10px"}}>
          {selectedSection && (
            <FeedbackSection
              key={selectedSection?.dataKey}
              dataKey={selectedSection?.dataKey}
              data={selectedSection?.data}
              metadata={selectedSection?.metadata}
              toggleShowMore={toggleShowMore}
              showMoreMap={showMoreMap} 
              source_click={handleSourceClick}
            />
          )}
        </div>
      </div>
      <div style={{flex: "0.35"}}>
      <div style={{display: "flex", flexDirection: "column", height: "100%"}}>
          <div style={{display: "flex", flexDirection: "column", background: "white", borderRadius: "10px 10px 6px 0", marginLeft: "10px"}} className='shadow-sm'>
            <div style={{ display: "flex", alignItems: "center", fontSize: "16px", fontWeight: "500", padding: "12px", borderBottom: "1px solid rgb(214, 214, 214)", borderRadius: "10px 10px 0 0", height: "46px"}}>
              {recordType === 'call' && (<><AiOutlineAudio style={{marginRight: "10px"}}/>Audio</>)}
              {recordType === 'chat' && (<><IoChatboxEllipsesOutline style={{marginRight: "10px"}}/>Chat</>)}
              </div>
              {recordType === 'call' && (<><div style={{marginTop: "10px"}}>
              <audio controls key={s3URL} ref={audioRef}
          onTimeUpdate={handleAudioTimeUpdate} onLoadedData={handleAudioLoad} onPlay={handleAudioPlay} onPause={handleAudioPause} onEnded={handleAudioEnded} onError={handleAudioError} style={{width: "96%", margin: "0 0.5rem", height: "40px"}}>
                <source src={s3URL} type="audio/mpeg" />
                Your browser does not support the audio element.
              </audio>
              </div>
              {agentCallTime && customerCallTime && <hr style={{margin: "10px 0"}}/>}
              {agentCallTime && customerCallTime && <div style={{margin: "0 10px", display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: "13px"}}>
                <SingleRowSegmentedChart data={[
                  {name: "Agent", value: agentCallTime, color: '#3b82f6'},
                  {name: "Customer", value: customerCallTime, color: '#10b981'},
                  {name: "Dead Air", value: deadAirTime, color: '#f59e0b'}
                ]}/>
              </div>}
              {rateOfSpeechAgent && rateOfSpeechCustomer && <hr style={{margin: "10px 0"}}/>}
              {rateOfSpeechAgent && rateOfSpeechCustomer && <div style={{margin: "0 10px", marginLeft: "23px", fontSize: "13px", display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                <span className='flex items-center'><span style={{background: "rgb(59, 130, 246)", width: "10px", height: "10px", borderRadius: "2px", marginRight: "5px", display: "flex"}}></span>Agent - {parseInt(rateOfSpeechAgent)} wpm</span>
                <span className='flex items-center'><span style={{background: "rgb(16, 185, 129)", width: "10px", height: "10px", borderRadius: "2px", marginRight: "5px", display: "flex"}}></span>Customer - {parseInt(rateOfSpeechCustomer)} wpm</span>
              </div>}
              <hr style={{margin: "10px 0"}}/>
              </>)}
              <div style={{margin:  "15px", height: (window.location.href.includes('?token=') && recordType === 'call') ? "66vh" : (recordType === 'chat' && !window.location.href.includes('?token=')) ? "77.5vh" : (recordType == 'chat' && window.location.href.includes('?token=')) ? "90vh" : (rateOfSpeechAgent && rateOfSpeechCustomer) ? "54vh" : "68vh", overflow: "auto"}} ref={transcriptRef}>
                    
                    {
                      segmentLoading && (
                      <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}>
                        <div className="loader"></div>
                        <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
                      </div>
                      )
                    }
                    {
                      !segmentLoading && segments && segments.length>0 && recordType === 'call' && segments.map((item, idx)=> {
                        const isSelected = selectedSegmentIdx === idx;
                        return (
                          <div key={`segment_${idx}`} ref={(el) => (segmentRefs.current[idx] = el)} onClick={()=>toggleSegment(item, idx)} style={{marginBottom: "10px", borderLeft: isSelected ? "4px solid #6f6ffe":"", background: isSelected ? "rgba(249, 250, 251, 1)":"",
                            padding: "2px 5px", minHeight: "50px", display: "flex", flexDirection: "column", justifyContent: "space-between", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", cursor: "pointer"}}>
                            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                              <div style={{fontSize: "14px", color: "grey"}}>{item.speaker}</div>
                              <div style={{fontSize: "14px", color: "grey"}}>{formatTime(item.start_time)}</div>
                            </div>
                            <div style={{fontSize: "15px", wordBreak: "break-word"}}>{item.text}</div>
                          </div>
                        )
                      })
                    }
                    {
                    !segmentLoading && segments.length === 0 && recordType === 'call' && (
                    <div className="flex justify-center items-center" style={{ height: "100%", flexDirection: "column" }}>
                        <img src="/assets/paper.png" style={{height: "10vh"}} alt=""/>
                        <h2 style={{textAlign: "center", fontSize: "24px"}}>Transcript Not Available.</h2>
                    </div>
                    )
                    }
                    {
                      !segmentLoading && chatTranscriptions && chatTranscriptions.length>0 && recordType === 'chat' && chatTranscriptions.map((item, idx)=> {
                        return (
                          <div key={`segment_${idx}`}
                          data-message-id={item.message_id}
                          style={{marginBottom: "10px", borderLeft: getBorderColor(item.actor_type), background: getBackgroundColor(item.actor_type),
                            padding: "2px 5px", minHeight: "50px", display: "flex", flexDirection: "column", justifyContent: "space-between", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", cursor: "pointer"}}>
                            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                              <div style={{fontSize: "10px", display: "flex", alignItems: "center"}}>
                                <span className='' style={{padding: "2px 8px", borderRadius: "10px", border: "1px solid rgba(0, 0, 0, 0.26)"}}>{item.actor_type}</span>
                                {item.message_type !== 'normal' && <span className=' ml-1' style={{padding: "2px 8px", borderRadius: "10px", border: "1px solid rgba(0, 0, 0, 0.26)"}}>{item.message_type}</span>}
                              </div>
                              <div style={{fontSize: "13px", color: "grey"}}>{formatEpochTime(item.timestamp)}</div>
                            </div>
                            <div style={{fontSize: "14px"}}><span style={{wordBreak: "break-all"}}>{item.content?.text?.content} <br/></span></div>
                            {item.content.image && item.content.image.url && 
                              <div style={{fontSize: "15px", wordBreak: "break-all"}}>
                                <br/>
                               Image Shared - {item.content.image.url}
                              </div>
                              }
                            {
                              item.content.buttons && item.content.buttons.length > 0 && (
                                <div>
                                  <br/>
                                  {item.actor_type === 'user' ? (
                                    <span>Button - Selected Option - {item.content.buttons.map(button => button.text).join(", ")}</span>
                                  ) : (
                                    <span>Button - Options - {item.content.buttons.map(button => button.text).join(", ")}</span>
                                  )}
                                </div>
                              )
                            }
                          </div>
                        )
                      })
                    }
                    {
                    !segmentLoading && chatTranscriptions.length === 0 && recordType === 'chat' && (
                    <div className="flex justify-center items-center" style={{ height: "100%", flexDirection: "column" }}>
                        <img src="/assets/paper.png" style={{height: "10vh"}} alt=""/>
                        <h2 style={{textAlign: "center", fontSize: "24px"}}>Transcript Not Available.</h2>
                    </div>
                    )
                    }
              </div>
          </div>
        </div>
      </div>
              </div>
            )
          }
          </>
        )
      }
      {
        showModal && (
            <div style={{ position: "fixed", height: "100%", width: "100%", top: 0, left: 0, zIndex: 10, background: "rgba(0, 0, 0, 0.5)" }}>
                <div style={{ position: "fixed", top: "7%",left: (window.innerWidth>760) ? "15%":"3.5%",width: (window.innerWidth>760) ? "70%":"93%",height: (window.innerWidth>760) ? "83%":"28%", zIndex: 999999999, background: "white", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)" }}>
                    <FeedbackLayout client_id={client_id} service_id={selectedOption} call_id={callId} manager_name={data.metadata?.manager_id} employee_name={data.metadata?.employee_id} close={handleCloseModal}/>
                </div>
            </div>
        )
      }
      {
        showRerunConfirm && (
          <div style={{ position: "fixed", height: "100%", width: "100%", top: 0, left: 0, zIndex: 9999999999, background: "rgba(0, 0, 0, 0.5)" }}>
            <div style={{ position: "fixed", top: "25%", left: (window.innerWidth>760) ? "32%":"3.5%", width: (window.innerWidth>760) ? "36%":"93%", background: "white", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)", padding: "16px", zIndex: 10000000000 }}>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <h3 className="text-xl" style={{fontWeight: 600, color: '#111827'}}>Confirm Rerun</h3>
                <button onClick={handleCloseRerunConfirm} className="text-gray-500 hover:text-gray-700"><FaTimes style={{color: 'slategray'}}/></button>
              </div>
              <div style={{marginTop: '12px', fontSize: '14px', color: '#374151'}}>
                <div>Apply to {rerunAffectedCount} conversations</div>
                <div style={{marginTop: '6px', color: '#6b7280'}}>Est. Credits: {Math.round(rerunTotalCost, 2) || '-'} | Current Balance: {Math.round(rerunCurrentBalance, 2) || '-'}</div>
                {rerunTotalCost > rerunCurrentBalance && rerunBalanceValid === 0 && (
                  <div style={{marginTop: '6px', color: '#ef4444'}}>Insufficient Credits. Please recharge or reduce selection.</div>
                )}
              </div>
              <div style={{display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '16px'}}>
                <button onClick={handleCloseRerunConfirm} className="px-4 py-2 border border-gray-300 rounded text-gray-700 text-base">Cancel</button>
                <button onClick={handleRerunApply} disabled={!canProceedRerun || isRerunApplying} className="px-4 py-2 rounded text-white font-medium text-base disabled:opacity-50 disabled:cursor-not-allowed" style={{ backgroundColor: 'rgb(79 70 229)' }}>{isRerunApplying ? 'Applying...' : 'Proceed'}</button>
              </div>
            </div>
          </div>
        )
      }
      {
                showAddModal && !callIdProp && (
                    <div style={{position: "fixed", left: "0%", top: "0%", width: "100%", height: "100%", background: "rgba(0, 0, 0, 0.5)", zIndex: "9999999999"}}>
                        <div style={{position: "fixed", left: "35%", top: "30%", width: "32%", height: "35%", background: "white", borderRadius: "10px", boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 3px", 
                        zIndex: "999999999", padding: "15px"}}>
                            <div style={{position: "absolute", right: "10px", top: "10px", cursor: "pointer"}} onClick={() => {setShowAddModal(false);}}><FaTimes style={{color: "slategray"}}/></div>
                            <AddSampleModal showType='Call' callId={callId} onCancel={handleCloseAddModal} onSave={handleSaveAddModalData}/>
                        </div>
                    </div>
                )
            }
      {
            loading && (
              <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}>
                <div className="loader"></div>
                <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
              </div>
            )
          }
          <style jsx>
            {`
            .sections-headings {
                            cursor: pointer;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            padding: 10px;
                            background: rgba(255, 255, 255, 0.28);
                            border-radius: 10px;
                            transition: background 0.3s;
                            }

                            .sections-headings.expanded {
                            border-bottom: 1px solid rgb(227, 227, 227);
                            border-radius: 10px 10px 0 0;
                            }

                            .sections-headings:hover {
                            background: rgb(249, 250, 251);
                            }

                            .section-title {
                            font-size: 15px;
                            font-weight: 500;
                            display: flex;
                            align-items: center;
                            }
            `}              
          </style>
    </div>
  );
};

export default CallDetails;
